import Vue from 'vue';
import lang from "element-ui/lib/locale/lang/ru-RU";
import locale from 'element-ui/lib/locale';
import width from './mixins/width';
import Auction from './pages/home/Auction';
import Offices from './pages/office/Offices';
import Feedback from './pages/feedback/Feedback';
import Contacts from './pages/contacts/Contacts';
import Faq from './pages/faq/Faq';
import Lot from './pages/lot/Lot';
import Comments from './pages/comments/Comments';
import VueCountdown from '@chenfengyuan/vue-countdown';
import infiniteScroll from 'vue-infinite-scroll';
import ResetPassword from "./pages/auth/ResetPassword";
import {Select, Option, Input, Checkbox, Dialog, Form, FormItem, Button} from "element-ui";
import {AppNotify} from "../../admin/js/utils/app-notify";
import {FirebaseMessages} from "../../js/modules/FirebaseMessages";
import HeaderStatistics from './components/HeaderStatistics';
import VueSocialSharing from 'vue-social-sharing'
import '@fortawesome/fontawesome-free/css/all.css';
import '@fortawesome/fontawesome-free/js/all.js';

locale.use(lang);
Vue.mixin(width);
Vue.use(Select);
Vue.use(Option);
Vue.use(Input);
Vue.use(Checkbox);
Vue.use(Dialog);
Vue.use(Form);
Vue.use(FormItem);
Vue.use(Button);
Vue.use(infiniteScroll);
Vue.use(AppNotify);
Vue.component(VueCountdown.name, VueCountdown);
Vue.use(VueSocialSharing);

window.Vue = Vue;
window.axios = require('axios');

//firebase notices
//FirebaseMessages.init();

new Vue({
    el: '#app',
    data: () => ({
        menu: false,
        email: '',
        password: '',
        password_confirm: '',
    }),
    components: {
        Auction, Lot, Offices, Feedback, Contacts, Faq, ResetPassword, Comments, HeaderStatistics
    },
});
